(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-product-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.design-cards__grid').forEach((grid) => {
      let isDown = false;
      let dragged = false;
      let startX = 0;
      let scrollStart = 0;

      grid.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        isDown = true;
        dragged = false;
        startX = event.clientX;
        scrollStart = grid.scrollLeft;
      });

      grid.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) {
          dragged = true;
          grid.classList.add('design-cards__grid--dragging');
        }
        if (dragged) {
          grid.scrollLeft = scrollStart - delta;
          event.preventDefault();
        }
      });

      function endDrag() {
        isDown = false;
        grid.classList.remove('design-cards__grid--dragging');
      }

      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointerleave', endDrag);
      grid.addEventListener('pointercancel', endDrag);

      grid.addEventListener(
        'click',
        (event) => {
          if (dragged) {
            event.preventDefault();
            event.stopPropagation();
            dragged = false;
          }
        },
        true
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fp-carousel__track').forEach((track) => {
      let isDown = false;
      let dragged = false;
      let startX = 0;
      let scrollStart = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        isDown = true;
        dragged = false;
        startX = event.clientX;
        scrollStart = track.scrollLeft;
      });

      track.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) {
          dragged = true;
          track.classList.add('fp-carousel__track--dragging');
        }
        if (dragged) {
          track.scrollLeft = scrollStart - delta;
          event.preventDefault();
        }
      });

      function endDrag() {
        isDown = false;
        track.classList.remove('fp-carousel__track--dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (dragged) {
            event.preventDefault();
            event.stopPropagation();
            dragged = false;
          }
        },
        true
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const footerContent = document.querySelector('.footer-content');
    if (!footerContent) return;

    const groups = footerContent.querySelectorAll(':scope > .group-block');

    groups.forEach((group) => {
      const heading = group.querySelector('h2, h3, h4');
      if (!heading) return;

      const contentWrapper = group.querySelector('.group-block-content');
      if (!contentWrapper) return;

      const headingWrapper = Array.from(contentWrapper.children).find((el) => el.contains(heading));
      const items = Array.from(contentWrapper.children).filter((el) => el !== headingWrapper);
      if (!items.length) return;

      const itemsWrap = document.createElement('div');
      itemsWrap.className = 'footer-accordion__items';
      items.forEach((el) => itemsWrap.appendChild(el));
      contentWrapper.appendChild(itemsWrap);

      const toggle = document.createElement('span');
      toggle.className = 'footer-accordion__toggle';
      toggle.setAttribute('aria-hidden', 'true');
      toggle.innerHTML =
        '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>';

      group.classList.add('footer-accordion');
      heading.classList.add('footer-accordion__heading');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');
      heading.appendChild(toggle);

      function toggleOpen() {
        const isOpen = group.classList.toggle('footer-accordion--open');
        heading.setAttribute('aria-expanded', String(isOpen));
      }

      heading.addEventListener('click', toggleOpen);
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleOpen();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-catalog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.product-catalog');
    if (!root) return;

    const cards = root.querySelectorAll('[data-category]');
    const categoryLinks = root.querySelectorAll('[data-category-link]');
    const subLinks = root.querySelectorAll('[data-subcategory-link]');
    const hoodieGroup = root.querySelector('[data-nav-group="hoodie"]');

    function applyFilter(category, subcategory) {
      cards.forEach((card) => {
        const matchesCategory = category === 'all' || card.dataset.category === category;
        const matchesSub = !subcategory || card.dataset.subcategory === subcategory;
        card.style.display = matchesCategory && matchesSub ? '' : 'none';
      });

      categoryLinks.forEach((link) => {
        link.classList.toggle('product-catalog__nav-item--active', link.dataset.categoryLink === category);
      });

      subLinks.forEach((link) => {
        link.classList.toggle(
          'product-catalog__nav-subitem--active',
          Boolean(subcategory) && link.dataset.subcategoryLink === subcategory
        );
      });

      if (hoodieGroup) {
        hoodieGroup.classList.toggle('product-catalog__nav-group--expanded', category === 'hoodie');
      }
    }

    function isPlainClick(e) {
      return !(e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0);
    }

    categoryLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        if (!isPlainClick(e)) return;
        e.preventDefault();
        applyFilter(link.dataset.categoryLink, null);
      });
    });

    subLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        if (!isPlainClick(e)) return;
        e.preventDefault();
        applyFilter('hoodie', link.dataset.subcategoryLink);
      });
    });

    const initialActive = root.querySelector('.product-catalog__nav-item--active');
    const initialCategory = initialActive ? initialActive.dataset.categoryLink : 'all';
    const initialType = new URLSearchParams(window.location.search).get('type');
    applyFilter(initialCategory, initialCategory === 'hoodie' ? initialType : null);
  });

  } catch(e) { console.error(e); }
})();
})();
